import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrazilianCurrencyPipe } from './pipes/brazilian-currency/brazilian-currency.pipe';
import { SentenceCasePipe } from './pipes/sentence-case/sentence-case.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [BrazilianCurrencyPipe, SentenceCasePipe],
  exports: [BrazilianCurrencyPipe, SentenceCasePipe],
  providers: [BrazilianCurrencyPipe],
})
export class CoreUtilsBrazilianCurrencyModule {}
